export const bosses = {
    Zakum: '자쿰의',
    Horntail: '',
    Hilla: '힐라',
    Cygnus: '노시그',
    Magnus: '하매',
    'Pink Bean': '카핑',
    Papulatus: '카파풀',
    'Crimson Queen': '블퀸',
    'Von Bon': '반반',
    Pierre: '피에르',
    Vellum: '카벨',
    Lotus: '스우',
    Damien: '데미안',
    'Guardian Angel Slime': '가엔슬',
    Lucid: '루시드',
    Will: '윌',
    Gloom: '더스크',
    Darknell: '듄켈',
    'Verus Hilla': '진힐라',
    'Black Mage': '검마',
    Seren: '세렌',
    Kalos: '칼로스',
    Kaling: '카링',
};
